<span class="air-heading">AIR Overview</span>
<div class="screen-wrapper">
    <div class="section-wrapper">
        
<np-tabbed id="TabSelection">
    <ul class="tabs">
        <li role="tab" aria-selected="true" class="installed-tab">Installed</li>
        <li role="tab" aria-selected="false" class="removed-tab">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
        <app-air-installed-tab [airAPIData]="airAPIData" />
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-air-removed-tab [airAPIData]="airAPIData"/>
    </div>

</np-tabbed>
        </div>

        <div class="section-wrapper">
            
<np-tabbed id="TabSelection">
    <ul class="tabs">
        <li role="tab" aria-selected="true" class="installed-tab">Installed</li>
        <li role="tab" aria-selected="false" class="removed-tab">Removed</li>
    </ul>

    <div class="tab-content" role="tabpanel" aria-hidden="false">
        <app-air-installed-save-tab [airAPIData]="airAPIData"/>
    </div>

    <div class="tab-content" role="tabpanel" aria-hidden="true">
        <app-air-removed-save-tab [airAPIData]="airAPIData"/>
    </div>

</np-tabbed>
        </div>
</div>